const SvgArrowForward = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 38 32">
    <path d="m22.396 32-1.13-1.13 14.071-14.068-35.335.065-.003-1.598 35.345-.065L21.266 1.129l1.13-1.13 16.004 16z" />
  </svg>;
export default SvgArrowForward;